var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "checkout__head" }, [
    _c("h1", [_vm._v(_vm._s(_vm.pageTitle))]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "checkout__head__steps" },
      _vm._l(_vm.steps, function (step) {
        return _c(
          "div",
          {
            key: step.name,
            staticClass: "checkout__head__steps__step",
            class: {
              active: "active" == step.state,
              completed: "completed" == step.state,
            },
          },
          [
            _c("span", [_vm._v(_vm._s(step.name))]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "checkout__head__steps__step__indicator" },
              [
                step.state == "completed"
                  ? _c(
                      "svg",
                      {
                        attrs: {
                          fill: "none",
                          height: "8",
                          viewBox: "0 0 12 8",
                          width: "12",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M11.0295 0.470312C11.3225 0.763281 11.3225 1.23906 11.0295 1.53203L5.02949 7.53203C4.73652 7.825 4.26074 7.825 3.96777 7.53203L0.967773 4.53203C0.674805 4.23906 0.674805 3.76328 0.967773 3.47031C1.26074 3.17734 1.73652 3.17734 2.02949 3.47031L4.4998 5.93828L9.97012 0.470312C10.2631 0.177343 10.7389 0.177343 11.0318 0.470312H11.0295Z",
                            fill: "white",
                          },
                        }),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/Checkout/Components/Common/Pagination.vue